// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2J3kt","input":"styles_input__3NU72"};